"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopoverIcon = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _PopoverIconMixin = require("../../mixins/components/PopoverIconMixin");
/**
 * A wrapper for `Icon` when used within a `Popover`.
 *
 * @since 7.41.0
 */
var PopoverIcon = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "PopoverIcon",
  componentId: "c11n-8-107-0__sc-c18bd2-0"
})(["", ""], _PopoverIconMixin.PopoverIconMixin);
exports.PopoverIcon = PopoverIcon;
PopoverIcon.displayName = 'PopoverIcon';

/** @component */